import React from 'react'
import { usePodcastEditor } from '../../context/use-podcast-editor'
import { Pencil } from 'lucide-react'
import { Skeleton } from '../../../../components/ui/skeleton'

export const TitleDisplay: React.FC = () => {
  const { podcast, beginEditTitle } = usePodcastEditor()
  
  if (!podcast?.title) {
    return (
      <div className="inline-flex items-center gap-2">
        <Skeleton height="5" width="48" />
      </div>
    )
  }
  
  return (
    <div className="group inline-flex items-center gap-2">
      <h1 className="text-sm font-semibold text-foreground truncate max-w-[40vw]">{podcast.title}</h1>
      <button
        type="button"
        className="opacity-0 cursor-pointer group-hover:opacity-100 transition-opacity text-foreground/70 hover:text-foreground"
        aria-label="Edit title"
        onClick={beginEditTitle}
      >
        <Pencil className="h-3.5 w-3.5" />
      </button>
    </div>
  )
}
